import CommercialList from '_modules/commercial/views/CommercialList.vue';
import CommercialEdit from '_modules/commercial/views/CommercialEdit.vue';
import Commercial from './Root.vue';


export default {
  path: 'comercial/',
  component: Commercial,
  name: 'admin-commercial-team',
  redirect: '/comercial/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-commercial-team-list',
      component: CommercialList,
    },
    {
      path: 'perfil',
      name: 'admin-commercial-team-perfil',
      component: CommercialEdit,
    },
  ],
};
